module.exports = __webpack_public_path__ + "static/img/006.1aa7d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/006.png
// module id = SfvJ
// module chunks = 0